import { createSelector } from '@ngrx/store';


import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import { entityTecnicoResponsableAdapter, EntityTecnicoResponsableState } from './entity-tecnico-responsable.state';
import { selectAuthPersona } from '../../persona/entity-personas/entity-personas.selectors';

const { selectEntities, selectAll } =
  entityTecnicoResponsableAdapter.getSelectors();

export const getError = (state: EntityTecnicoResponsableState): any =>
  state.error;

export const getIsLoading = (state: EntityTecnicoResponsableState): boolean =>
  state.isLoading;

export const selectTecnicoResponsableState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.tecnicosResponsables
);

export const selectAllTecnicoResponsable = createSelector(
  selectTecnicoResponsableState,
  selectAll
);
export const selectEntitiesTecnicoResponsable = createSelector(
  selectTecnicoResponsableState,
  selectEntities
);

export const selectAuthTecnicoResponsable = createSelector(
  selectAllTecnicoResponsable, selectAuthPersona,
  (tecnicosResponsable, persona ) => tecnicosResponsable.find(tr => tr.tecnico.persona_id === persona.id)
)

// MemoizedSelector<object,any>
export const selectTecnicoResponsableError = createSelector(
  selectTecnicoResponsableState,
  getError
);

// MemoizedSelector<object,any>
export const selectTecnicoResponsableIsLoading = createSelector(
  selectTecnicoResponsableState,
  getIsLoading
);
